module.exports = function (text) {
    if (!text) return '';

    return text
        .trim()
        .toLowerCase()
        .replace(/\W+/g, '-')
        .replace(/_/g, '-')
        .replace(/(-){2}/g, '')
        .replace(/^-|-$/g, '') || '';
};